import { ReactNode } from 'react';

interface InfoCalloutProps {
  position: 'left' | 'right';
  x: number;
  y: number;
  title: string;
  value?: string;
  description?: string;
  color?: string;
  icon?: ReactNode;
}

export const InfoCallout = ({
  position,
  x,
  y,
  title,
  value,
  description,
  color = '#64748b',
}: InfoCalloutProps) => {
  const isLeft = position === 'left';
  const textX = isLeft ? x - 10 : x + 10;
  const anchor = isLeft ? 'end' : 'start';

  return (
    <g>
      <line
        x1={x}
        y1={y}
        x2={isLeft ? x - 60 : x + 60}
        y2={y}
        stroke={color}
        strokeWidth="1.5"
        strokeOpacity="0.5"
      />

      <circle cx={x} cy={y} r="3" fill={color} opacity="0.8" />

      <text
        x={textX}
        y={y - 12}
        fontSize="13"
        fontWeight="600"
        fill="#1e293b"
        textAnchor={anchor}
      >
        {title}
      </text>

      {value && (
        <text
          x={textX}
          y={y + 5}
          fontSize="15"
          fontWeight="700"
          fill={color}
          textAnchor={anchor}
        >
          {value}
        </text>
      )}

      {description && (
        <text
          x={textX}
          y={y + 20}
          fontSize="10"
          fill="#64748b"
          textAnchor={anchor}
        >
          {description}
        </text>
      )}
    </g>
  );
};
